import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Skeleton } from 'antd';
import { numberWithCommas } from 'utils/stringUtils';
import { generate } from 'shortid';
import { modalMethod } from 'components/Modal';

interface PayInfoModalProps {
  open: boolean;
  isLoading?: boolean;
  close?: () => void;
  data?: any;
  menus?: any[];
  shippingFeeInfos?: any[];
  supplyType?: any;
  onCancelPayment?: (couponId: string, cancelMessage: string) => void;
  isCancelable?: boolean;
  hasNonRefundableReasons?: boolean;
  nonRefundables?: any[];
}

// 취소사유 선택 컴포넌트
const CancelReasonSelector = ({
  selectedCancelReason,
  setSelectedCancelReason,
  customReasonText,
  setCustomReasonText,
  onConfirm,
  onCancel,
  hasNonRefundableReasons,
  nonRefundables
}: {
  selectedCancelReason: string;
  setSelectedCancelReason: (reason: string) => void;
  customReasonText: string;
  setCustomReasonText: (text: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  hasNonRefundableReasons?: boolean;
  nonRefundables?: any[];
}) => {
  return (
    <div style={{ padding: '0', margin: '0' }}>
      {/* 메인 메시지 */}
      <div style={{ marginBottom: '16px', textAlign: 'left' }}>
        <div style={{ marginBottom: '8px' }}>결제 취소 완료 후에는 복원이 불가합니다.</div>
        <div>앱내 카드결제는 정상적으로 환불 처리됩니다.</div>
      </div>

      {/* 포인트 환불 정보 영역 */}
      {hasNonRefundableReasons && (
        <div style={{ marginBottom: '16px' }}>
          {/* 포인트 환불 */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '8px',
              fontSize: '12px',
              lineHeight: '18px'
            }}
          >
            <div
              style={{
                width: '110px',
                fontWeight: 'bold',
                color: '#212529'
              }}
            >
              포인트 환불
            </div>
            <div
              style={{
                color: '#FA503C',
                width: '190px',
                fontWeight: 'bold'
              }}
            >
              환불불가 포인트가 존재합니다.
            </div>
          </div>

          {/* 포인트 환불 불가 사유들 */}
          {nonRefundables &&
            nonRefundables.map((item: any, index: number) => (
              <div
                key={`nonRefundable-${generate()}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '4px',
                  fontSize: '12px',
                  lineHeight: '18px'
                }}
              >
                <div
                  style={{
                    width: '110px',
                    fontWeight: 'bold',
                    color: '#212529'
                  }}
                >
                  {index === 0 ? '포인트 환불 불가 사유' : ' '}
                </div>
                <div
                  style={{
                    color: '#212529',
                    width: '190px'
                  }}
                >
                  {item.reason}
                </div>
              </div>
            ))}
        </div>
      )}

      {/* 구분선 */}
      <div style={{ height: '1px', backgroundColor: '#E2E2E2', margin: '16px 0' }} />

      {/* 취소사유 선택 */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ marginBottom: '8px', textAlign: 'left' }}>
          <span style={{ fontWeight: 'bold' }}>[필수] 취소사유</span>
          <span style={{ fontSize: '12px', color: '#666', marginLeft: '8px' }}>취소사유를 선택 혹은 입력해 주세요</span>
        </div>

        {/* 취소사유 옵션들 */}
        <div style={{ marginBottom: '12px' }}>
          <button
            type="button"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '8px',
              cursor: 'pointer',
              border: 'none',
              background: 'transparent',
              padding: '0',
              width: '100%',
              textAlign: 'left'
            }}
            onClick={() => {
              console.log('착오결제 옵션 클릭됨');
              setSelectedCancelReason('misunderstanding');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                console.log('착오결제 옵션 키보드 선택됨');
                setSelectedCancelReason('misunderstanding');
              }
            }}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #ccc',
                borderRadius: '50%',
                backgroundColor: selectedCancelReason === 'misunderstanding' ? '#FA503C' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              {selectedCancelReason === 'misunderstanding' && (
                <div style={{ width: '6px', height: '6px', backgroundColor: 'white', borderRadius: '50%' }} />
              )}
            </div>
            <span>착오결제(타매장 이용)로 결제취소</span>
          </button>
          <button
            type="button"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '8px',
              cursor: 'pointer',
              border: 'none',
              background: 'transparent',
              padding: '0',
              width: '100%',
              textAlign: 'left'
            }}
            onClick={() => {
              console.log('금액/결제수단 변경 옵션 클릭됨');
              setSelectedCancelReason('change');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                console.log('금액/결제수단 변경 옵션 키보드 선택됨');
                setSelectedCancelReason('change');
              }
            }}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #ccc',
                borderRadius: '50%',
                backgroundColor: selectedCancelReason === 'change' ? '#FA503C' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              {selectedCancelReason === 'change' && (
                <div style={{ width: '6px', height: '6px', backgroundColor: 'white', borderRadius: '50%' }} />
              )}
            </div>
            <span>금액/결제수단 변경으로 결제취소</span>
          </button>
          <button
            type="button"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '8px',
              cursor: 'pointer',
              border: 'none',
              background: 'transparent',
              padding: '0',
              width: '100%',
              textAlign: 'left'
            }}
            onClick={() => {
              console.log('직접입력 옵션 클릭됨');
              setSelectedCancelReason('custom');
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                console.log('직접입력 옵션 키보드 선택됨');
                setSelectedCancelReason('custom');
              }
            }}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #ccc',
                borderRadius: '50%',
                backgroundColor: selectedCancelReason === 'custom' ? '#FA503C' : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              {selectedCancelReason === 'custom' && (
                <div style={{ width: '6px', height: '6px', backgroundColor: 'white', borderRadius: '50%' }} />
              )}
            </div>
            <span>취소 사유 직접입력</span>
          </button>
        </div>

        {/* 직접입력 필드 */}
        <div
          style={{
            backgroundColor: selectedCancelReason === 'custom' ? 'white' : '#f5f5f5',
            padding: '8px',
            borderRadius: '4px',
            border: selectedCancelReason === 'custom' ? '1px solid #FA503C' : '1px solid #ddd',
            textAlign: 'left',
            color: selectedCancelReason === 'custom' ? '#212529' : '#999'
          }}
        >
          {selectedCancelReason === 'custom' ? (
            <div>
              <input
                type="text"
                value={customReasonText}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.length <= 30) {
                    setCustomReasonText(value);
                  }
                }}
                placeholder="취소사유를 입력해주세요(30자 이하)"
                maxLength={30}
                style={{
                  width: '100%',
                  border: 'none',
                  outline: 'none',
                  fontSize: '12px',
                  backgroundColor: 'transparent',
                  marginBottom: '4px'
                }}
              />
              <div
                style={{
                  fontSize: '11px',
                  color: customReasonText.length >= 30 ? '#FA503C' : '#999',
                  textAlign: 'right'
                }}
              >
                {customReasonText.length}/30
              </div>
            </div>
          ) : (
            <span>취소사유를 입력해주세요(30자 이하)</span>
          )}
        </div>
      </div>

      {/* 버튼 영역 */}
      <div
        style={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'flex-end',
          marginTop: '24px',
          padding: '16px 0 0 0',
          borderTop: '1px solid #E2E2E2'
        }}
      >
        <button
          type="button"
          onClick={onCancel}
          style={{
            padding: '8px 16px',
            border: '1px solid #E2E2E2',
            backgroundColor: 'transparent',
            color: '#0067FF',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          닫기
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={!selectedCancelReason || (selectedCancelReason === 'custom' && customReasonText.trim().length === 0)}
          style={{
            padding: '8px 16px',
            border: '1px solid #FA503C',
            backgroundColor: '#transparent',
            color:
              selectedCancelReason && (selectedCancelReason !== 'custom' || customReasonText.trim().length > 0)
                ? '#FA503C'
                : '#999999',
            borderRadius: '4px',
            cursor:
              selectedCancelReason && (selectedCancelReason !== 'custom' || customReasonText.trim().length > 0)
                ? 'pointer'
                : 'not-allowed'
          }}
        >
          결제취소
        </button>
      </div>
    </div>
  );
};

const PayInfoModal = ({
  open,
  close,
  data,
  menus,
  shippingFeeInfos,
  supplyType,
  isLoading,
  onCancelPayment,
  isCancelable,
  hasNonRefundableReasons,
  nonRefundables
}: PayInfoModalProps) => {
  /*
			시현으로 인한 회사명 미노출 코드
		 */
  // const id = sessionStorage.getItem('storeAdminId');
  // const testid = 'hvendys';

  // 취소사유 선택 상태 관리
  const [selectedCancelReason, setSelectedCancelReason] = useState<string>('');
  const [customReasonText, setCustomReasonText] = useState<string>('');
  const [showCancelReasonSelector, setShowCancelReasonSelector] = useState<boolean>(false);

  // 모달이 열릴 때 상태 초기화
  useEffect(() => {
    if (open) {
      setSelectedCancelReason('');
      setCustomReasonText('');
      setShowCancelReasonSelector(false);
      console.log('모달 열림 - 상태 초기화됨');
    }
  }, [open]);

  // 상태 변경 디버깅
  useEffect(() => {
    console.log('선택된 취소사유 변경:', selectedCancelReason);
  }, [selectedCancelReason]);

  const handleCancelPayment = () => {
    if (data?.couponId && onCancelPayment) {
      // detail.isCancelable이 false인 경우 결제취소 불가 모달 표시
      if (isCancelable === false) {
        modalMethod.info(
          <div>
            <div>해당 결제건은 취소가 불가능합니다.</div>
            <div>자세한 사항은 1:1 문의하기를 이용바랍니다.</div>
          </div>,
          {
            okText: '닫기',
            zIndex: 10000
          }
        );
      } else if (isCancelable === true) {
        // 취소사유 선택 화면 표시
        setShowCancelReasonSelector(true);
      }
    }
  };

  const handleCancelConfirm = () => {
    if (selectedCancelReason && onCancelPayment) {
      // 선택된 취소사유를 cancelMessage로 변환
      let cancelMessage = '';

      switch (selectedCancelReason) {
        case 'misunderstanding':
          cancelMessage = '착오결제(타매장 이용)로 결제취소';
          break;
        case 'change':
          cancelMessage = '금액/결제수단 변경으로 결제취소';
          break;
        case 'custom':
          cancelMessage = customReasonText || '취소 사유 직접입력';
          break;
        default:
          cancelMessage = '기타 사유로 결제취소';
      }

      onCancelPayment(data.couponId, cancelMessage);
    }
  };

  const handleCancelBack = () => {
    setShowCancelReasonSelector(false);
    setSelectedCancelReason('');
    setCustomReasonText('');
  };

  const totalPrice = numberWithCommas(data?.totalPrice);

  const menusTotal = menus && menus.length > 0 ? menus.reduce((acc, cur) => acc + cur.count * cur.price, 0) : 0;
  const shippingFeeTotal =
    shippingFeeInfos && shippingFeeInfos.length > 0 ? shippingFeeInfos.reduce((acc, cur) => acc + cur.totalFee, 0) : 0;

  // 모달 내용 렌더링 함수
  const renderModalContent = () => {
    if (showCancelReasonSelector) {
      return (
        <CancelReasonSelector
          selectedCancelReason={selectedCancelReason}
          setSelectedCancelReason={setSelectedCancelReason}
          customReasonText={customReasonText}
          setCustomReasonText={setCustomReasonText}
          onConfirm={handleCancelConfirm}
          onCancel={handleCancelBack}
          hasNonRefundableReasons={hasNonRefundableReasons}
          nonRefundables={nonRefundables}
        />
      );
    }

    if (isLoading) {
      return <Skeleton active />;
    }

    return (
      <div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">결제번호</label>
          <div className="col-sm-4">{data?.payRoomIdx}</div>
          <label className="col-sm-2 col-form-label">결제자</label>
          <div className="col-sm-4">{data?.leaderName}</div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">결제일시</label>
          <div className="col-sm-4">{data?.useDate ? moment(data.useDate * 1000).format('YYYY-MM-DD HH:mm:ss') : null}</div>
          <label className="col-sm-2 col-form-label">사용형태</label>
          <div className="col-sm-4">{data?.couponType === 'SINGLE' ? '혼자결제' : '함께결제'}</div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">회사명</label>
          <div className="col-sm-4">{data?.comName}</div>
          <label className="col-sm-2 col-form-label">상태</label>
          <div className="col-sm-4">{data?.paymentStatus === 'USED' ? '결제완료' : '결제취소'}</div>
        </div>
        <hr />
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">메뉴/상품 금액</label>
        </div>
        <table className="table menuTable min-height-auto table-hover">
          <thead className="menuHead">
            <tr>
              <th scope="col">메뉴/상품명</th>
              <th scope="col">수량</th>
              <th scope="col">결제금액</th>
            </tr>
          </thead>
          <tbody>
            {menus && menus.length > 0 ? (
              menus.map((row) => {
                const { menuId, menuName, price, count } = row;
                return (
                  <tr className="table-row" key={menuId}>
                    <td>{menuName}</td>
                    <td>{numberWithCommas(count)}</td>
                    <td>{numberWithCommas(price)}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="no-content" colSpan={3}>
                  검색 결과가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={2} />
              <td>{numberWithCommas(menusTotal)}</td>
            </tr>
          </tfoot>
        </table>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">배송비</label>
        </div>
        <table className="table menuTable min-height-auto table-hover">
          <thead className="menuHead">
            <tr>
              <th scope="col">배송비</th>
              <th scope="col">기본 배송비</th>
              <th scope="col">조건부 추가배송비</th>
              <th scope="col">제주/도서 추가배송비</th>
              <th scope="col">결제금액</th>
            </tr>
          </thead>
          <tbody>
            {shippingFeeInfos && shippingFeeInfos.length > 0 ? (
              shippingFeeInfos.map((row) => {
                const { feeConditionName, defaultFee, conditionalFee, addressFee, totalFee } = row;
                return (
                  <tr className="table-row" key={generate()}>
                    <td>{feeConditionName || '-'}</td>
                    <td>{defaultFee !== null ? numberWithCommas(defaultFee) : '-'}</td>
                    <td>{conditionalFee !== null ? numberWithCommas(conditionalFee) : '-'}</td>
                    <td>{addressFee !== null ? numberWithCommas(addressFee) : '-'}</td>
                    <td>{totalFee !== null ? numberWithCommas(totalFee) : '-'}</td>
                  </tr>
                );
              })
            ) : (
              <tr className="table-row">
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={4} />
              <td>
                {typeof shippingFeeTotal !== 'undefined' && shippingFeeTotal !== null && supplyType === 7
                  ? numberWithCommas(shippingFeeTotal)
                  : '없음'}
              </td>
            </tr>
          </tfoot>
        </table>
        <div className="form-group row menutotal">
          <label className="col-sm-4 col-form-label name">결제금액</label>
          <div className="col-sm-8 price total-price">{totalPrice}</div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (open === true) {
      // TODO delete bootstrap
      // eslint-disable-next-line
      // @ts-ignore
      $('#payModal').modal('show');
    } else if (open === false) {
      // TODO delete bootstrap
      // eslint-disable-next-line
      // @ts-ignore
      $('#payModal').modal('hide');
    }
  }, [open]);
  useEffect(() => {
    // TODO delete bootstrap
    // eslint-disable-next-line
    // @ts-ignore
    $('#payModal').on('hidden.bs.modal', () => {
      close();
    });
  }, [close]);

  return (
    <div>
      <div id="payModal" className="modal fade" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content payModal">
            <div className="modal-header">
              <h4 className="modal-title">상세 정보</h4>
            </div>
            <div className="modal-body" style={{ padding: '20px', margin: '0' }}>
              {renderModalContent()}
            </div>
            <div className="modal-footer" style={{ padding: '15px 20px', margin: '0', borderTop: '1px solid #dee2e6' }}>
              {!showCancelReasonSelector && data?.paymentStatus === 'USED' && (
                <button type="button" className="btn btn-cancel-payment" onClick={handleCancelPayment}>
                  결제취소
                </button>
              )}
              {!showCancelReasonSelector && (
                <button type="button" className="btn btn-sikdae" data-dismiss="modal">
                  확인
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayInfoModal;
